<template>
  <div class="pipelineview">
    <v-row>
      <v-col>
        <PipelineComponent :steps="steps" v-model="completedStepsModel"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        Step: {{completedStepsModel}}
      </v-col>
    </v-row>

    <v-row>
      <v-col md="6" class="overflow" >
        <PipelineComponent class="theme--marketplace" :steps="items.map((item) => {return item.name})" v-model="completedStepsSalesModel" :inactive="true"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="8">
        Edit Mode

        <CardComponent>
          <SalesPipelineEditor v-model="items" />
        </CardComponent>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import {ref, reactive, watch} from '@vue/composition-api'

import PipelineComponent from "@/components/lead/PipelineComponent";
import SalesPipelineEditor from "@/components/form/SalesPipelineEditor";
import CardComponent from "../components/form/CardComponent";

export default {
  name: "PipelineView",
  components: {
    CardComponent,
    PipelineComponent,
    SalesPipelineEditor
  },
  setup() {
    const steps = ['Quality', 'Develop', 'Propose', 'Go Go Go', 'Win'];
    const completedStepsModel = ref(3);
    const completedStepsSalesModel = ref(0);
    
    const items = reactive([
      {
        id: "item_1",
        name: "Kontaktaufnahme",
        duration: "01:12:45",
        interval: 'täglich',
      },
      {
        id: "item_2",
        name: "Bedarfsanalyse",
        duration: "02:34:17",
        interval: 'wöchentlich'
      },
      {
        id: "item_3",
        name: "Buying-Center involvieren",
        duration: "08:00:08",
        interval: 'monatlich'
      },
      {
        id: "item_4",
        name: "Präsentation",
        duration: "08:00:08",
        interval: 'monatlich'
      }

    ]);

    watch(() => items, () => {
      // console.log('watcher', items);
    },{deep:true});

    return {steps, completedStepsModel, completedStepsSalesModel, items};
  }
}
</script>

<style lang="scss">
  // make pipeline scroll
  .overflow{
    > div{
      overflow-x: auto;
      .stepper-container{
        flex-wrap: nowrap;
      }
    }
  }
</style>
